// extracted by mini-css-extract-plugin
export default {"links":"Setting_links__D2pEE"};